import React from "react";
import {Col, Form, Row} from "react-bootstrap";

export default function Year({ controlId, defaultValue, isValid, onChange, required }) {
    function getDropList() {
        const year = new Date().getFullYear() - 24;

        return Array.from(new Array(26), (v, i) => (
          <option key={i} value={year + i}>
              {year + i}
          </option>
        ));
    }
    return (
        <>
            <Form.Group as={Col} sm={4} controlId={controlId}>
                <Form.Control
                    as="select"
                    className="form-control"
                    required={required}
                    data-hj-allow
                    isInvalid={isValid !== undefined && !isValid}
                    value={defaultValue}
                    onChange={onChange}>
                    <option value="">Year</option>
                    {getDropList()}
                </Form.Control>
            </Form.Group>
        </>
    )
}